import { TApplicationState } from '../../types/redux';

export function getDescription(state: TApplicationState) {
  const {
    newbuilding: { description },
  } = state;

  if (description && description.length) {
    return description;
  }

  return null;
}
